import { computePosition, flip } from '@floating-ui/dom';

const planTooltips = document.querySelectorAll( '.plan-tooltip-button' );
const hsaTooltips = document.querySelectorAll( '.hsa-badge' );

// Function to update tooltip position
function update( button, tooltip ) {
	computePosition( button, tooltip, {
		placement: 'top',
		middleware: [ flip() ],
	} ).then( ( { x, y } ) => {
		Object.assign( tooltip.style, {
			left: `${ x }px`,
			top: `${ y }px`,
		} );
	} );
}

// Function to show tooltip
function showTooltip( button, tooltip ) {
	tooltip.style.display = 'block';
	update( button, tooltip );
}

// Function to hide tooltip
function hideTooltip( tooltip ) {
	tooltip.style.display = '';
}

// Set up each button and tooltip pair
function setUpTooltipPair( buttons, persistent = false ) {
	buttons.forEach( ( button ) => {
		const tooltipId = button.getAttribute( 'aria-describedby' );
		const tooltip = document.getElementById( tooltipId );

		if ( tooltip ) {
			// Attach event listeners for showing and hiding the tooltip on the button
			[
				[ 'mouseenter', () => showTooltip( button, tooltip ) ],
				[
					'mouseleave',
					() => {
						if ( ! persistent || ! tooltip.matches( ':hover' ) ) {
							hideTooltip( tooltip );
						}
					},
				],
				[ 'focus', () => showTooltip( button, tooltip ) ],
				[ 'blur', () => hideTooltip( tooltip ) ],
			].forEach( ( [ event, listener ] ) => {
				button.addEventListener( event, listener );
			} );

			if ( persistent ) {
				// Add event listeners to the tooltip itself for persistent tooltips
				tooltip.addEventListener( 'mouseenter', () =>
					showTooltip( button, tooltip )
				);
				tooltip.addEventListener( 'mouseleave', () => hideTooltip( tooltip ) );
			}
		}
	} );
}

// Set up planTooltips without persistence and hsaTooltips with persistence
setUpTooltipPair( planTooltips );
setUpTooltipPair( hsaTooltips, true );


// Function to populate plan tier dropdown options
// Also handles event change - loads instant rates page based on selected tier
function planTierDropdown() {
	const primaryTabs = document.getElementById('primary-tabs');
	if (!primaryTabs) return;

	const urlParams = new URLSearchParams(window.location.search);
	const tier = urlParams.get('tier');

	const coverageDetails = {
		'employee-only': { title: 'Primary', coverage: '', spousedob: '', spousegender: '', numberchild: '', tier: 'employee-only' },
		'employee-spouse': { title: 'Primary + Spouse', coverage: 'Married', spousedob: '01/01/2000', spousegender: 'Female', numberchild: '', tier: 'employee-spouse' },
		'employee-children': { title: 'Primary + Children', coverage: 'Yes', spousedob: '', spousegender: '', numberchild: '2', tier: 'employee-children' },
		'employee-children-one': { title: 'Primary + 1 Child', coverage: 'Yes', spousedob: '', spousegender: '', numberchild: '1', tier: 'employee-children-one' },
		'employee-children-two': { title: 'Primary + 2+ Children', coverage: 'Yes', spousedob: '', spousegender: '', numberchild: '2', tier: 'employee-children-two' },
		'family': { title: 'Family', coverage: 'Married, Yes', spousedob: '01/01/2000', spousegender: 'Female', numberchild: '2', tier: 'family' }
	};

	const dataTier = document.getElementById('page')?.dataset.tier;
	const excludedTiers = dataTier === 'primary-one-child'
		? ['employee-children']
		: ['employee-children-one', 'employee-children-two'];

	const planTierDropdowns = document.querySelectorAll('.plan-tier-dropdown');
	planTierDropdowns.forEach((select) => {
		Object.entries(coverageDetails).forEach(([key, details]) => {
			if (!excludedTiers.includes(key)) {
				select.appendChild(new Option(details.title, key));
			}
		});

		select.value = tier;
	});


	const pageSlug = document.getElementById('page')?.dataset.slug;
	const { account, acronym, siteUrl, programName } = primaryTabs.dataset;
  	const urlSnippet = `first=${acronym}&last=${acronym}&email=${acronym}@plans.com&dob=01/01/2000&gender=Male&homezip=37128`;

	planTierDropdowns.forEach((dropdown) => {
    dropdown.addEventListener('change', (e) => {
      e.preventDefault();
      const selectedTier = dropdown.value;
      const details = coverageDetails[selectedTier];

      if (details) {
        const params = new URLSearchParams({
          coverage: details.coverage,
          spousedob: details.spousedob,
          spousegender: details.spousegender,
          numberchild: details.numberchild,
          effectivedate: '03/01/2025',
          account,
          tier: details.tier
        });

        const url = `${siteUrl}/${pageSlug}/?${urlSnippet}&${params.toString()}`;
        window.location.href = url;
      }
    });
  });
};

planTierDropdown();

// Add .expanded class to highlight dropdown and select text
function updatePlanTier() {
	const updatePlanTierLinks = document.querySelectorAll('.update-plan-tier-link');
	const selectDifferentTier = document.querySelectorAll(".select-different-tier");
	
	updatePlanTierLinks.forEach((link) => {
		const targetDropdown = document.querySelector(link.dataset.expand);

		if (targetDropdown) {
	        link.addEventListener("click", function (event) {
	            event.preventDefault(); 

	            targetDropdown.classList.add("expanded");
							selectDifferentTier.forEach((selectTier) => {
								selectTier.classList.add("expanded");
							});

	            setTimeout(() => {
	                targetDropdown.classList.remove("expanded");
									selectDifferentTier.forEach((selectTier) => {
										selectTier.classList.remove("expanded");
									});
	            }, 600);
	        });
	    }
	});
}

updatePlanTier();